
define(
	'Code25.CaterpartsGlobal.AdvSearch'
	, [
		"Handlebars", "Utils", "Code25.CaterpartsGlobal.AdvSearch.View"
	]
	, function (
		Handlebars, Utils, Code25CaterpartsGlobalAdvSearchView
	) {
		'use strict';

		return {
			mount: function mount(container) {

				var layout = container.getComponent('Layout');
				layout.registerView('AdvSearch', function () {
					return new Code25CaterpartsGlobalAdvSearchView({ application: container });
				});

			}
		};

	});
